import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';
import { apiName, apiBasePath } from 'assets/constants';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

export async function getFeedback(kitId: string, pageType: string) {
  const response = await API.get(
    apiName,
    `${apiBasePath}/feedback/${kitId}/${pageType}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.FEEDBACK,
        importance: IMPORTANCE.LOW,
      },
      context: {
        kitId,
        pageType,
      },
    },
  );
  return response;
}

const useKitFeedback = (kitId: string | null, pageType: string) => {
  const kitFeedbackQuery = useSuspenseQuery({
    queryKey: [apiName, 'feedback', kitId, pageType],
    queryFn: () => !!kitId && !!pageType && getFeedback(kitId, pageType),
  });
  return kitFeedbackQuery;
};

export default useKitFeedback;
